import React from 'react';
import {FiCheckCircle, FiFileText, FiUser} from 'react-icons/fi';
import MathText from '../components/MathText';
import {
    feedbackCategoryLabels,
    feedbackScopeLabels,
    formatFeedbackDate,
} from './examFeedbackUtils';

const value = (input) => input === null || input === undefined || input === '' ? '—' : input;

const gradingTypeLabels = {
    manual: 'تصحیح دستی',
    automatic: 'تصحیح خودکار',
    auto: 'تصحیح خودکار',
};

const gradingStatusLabels = {
    not_graded: 'در انتظار تصحیح',
    auto_graded: 'تصحیح خودکار',
    manually_graded: 'تصحیح دستی',
};

export default function FeedbackDetails({feedback}) {
    if (!feedback) return null;
    const snapshot = feedback.snapshot || {};
    const answer = snapshot.answer;
    return <div className="ef-feedback-detail">
        <section className="ef-feedback-student">
            <span><FiUser/></span>
            <div><strong>{feedback.student?.full_name || 'دانشجو'}</strong><small>{feedback.student?.email || 'ایمیل ثبت نشده'}</small></div>
            <b>{feedback.rating == null ? 'بدون امتیاز' : `${feedback.rating} از ۵`}</b>
        </section>

        <div className="ef-feedback-badges">
            <span>{feedbackScopeLabels[feedback.scope] || feedback.scope}</span>
            <span>{feedbackCategoryLabels[feedback.category] || feedback.category}</span>
            {feedback.consent_for_improvement && <span className="consent"><FiCheckCircle/> مجاز برای بهبود</span>}
        </div>

        <section className="ef-feedback-comment">
            <small>متن بازخورد</small>
            <p>{feedback.comment || 'بدون توضیح'}</p>
            <time>{formatFeedbackDate(feedback.created_at)}</time>
        </section>

        <section className="ef-feedback-context">
            <header><FiFileText/><div><h3>{snapshot.exam_title || `آزمون ${feedback.exam_id}`}</h3><p>اطلاعات ثبت‌شده در زمان ارسال بازخورد</p></div></header>
            <dl>
                <div><dt>شماره تلاش</dt><dd>{value(snapshot.attempt_number)}</dd></div>
                <div><dt>نمره تلاش</dt><dd>{value(snapshot.attempt_score)} از {value(snapshot.attempt_max_score)}</dd></div>
                <div><dt>زمان انتشار نتیجه</dt><dd>{formatFeedbackDate(snapshot.results_released_at)}</dd></div>
                <div><dt>شناسه دوره</dt><dd>{value(snapshot.course_id)}</dd></div>
            </dl>
        </section>

        {answer && <section className="ef-snapshot ef-feedback-answer">
            <header><h4>جزئیات سؤال و پاسخ</h4><span>سؤال {value(answer.position)}</span></header>
            <h3 className="bidi-content"><MathText text={answer.prompt || 'متن سؤال در دسترس نیست.'}/></h3>
            <div className="ef-answer-columns">
                <div><small>پاسخ دانشجو</small><p className="bidi-content"><MathText text={answer.student_answer || 'بدون پاسخ'}/></p></div>
                <div><small>پاسخ معیار</small><p className="bidi-content"><MathText text={answer.reference_answer || '—'}/></p></div>
            </div>
            {answer.explanation && <div className="ef-feedback-explanation"><small>توضیح پاسخ</small><p className="bidi-content"><MathText text={answer.explanation}/></p></div>}
            <div className="ef-answer-meta">
                <span>نمره: <b>{value(answer.awarded_points)}</b> از <b>{value(answer.question_points)}</b></span>
                <span>{gradingTypeLabels[answer.grading_type] || answer.grading_type || 'نوع تصحیح نامشخص'}</span>
                <span>{gradingStatusLabels[answer.grading_status] || answer.grading_status || 'وضعیت نامشخص'}</span>
                <span>تصحیح: {formatFeedbackDate(answer.graded_at)}</span>
            </div>
            {answer.teacher_feedback && <div className="ef-teacher-feedback"><small>بازخورد قبلی استاد</small><p className="bidi-content"><MathText text={answer.teacher_feedback}/></p></div>}
        </section>}
    </div>;
}

